<!-- View DialogIssueExternalCouponFail -->
<template>
  <ItemDialog ref="issueExternalCouponFail" imageType="coupon">
    <template v-slot:content-area>
      <div class="text-caution">
        <h1>
          <strong>エラーが発生しました</strong>
        </h1>
      </div>
      <div class="text-center">
        <p>クーポンが付与されませんでしました。​</p>
        <p>「リトライ」ボタンを押して発行を お試しください。​</p>
      </div>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="リトライ"
        actionType="btn-primary"
        @clicked="retry()"
      />
      <ItemButton
        label="キャンセル"
        actionType="btn-cancel"
        @clicked="closeDialog"
      />
    </template>
  </ItemDialog>
</template>
  
  <script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogIssueExternalCouponFail",
  props: {
    retry: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const issueExternalCouponFail = ref(null);

    const openDialog = () => {
      issueExternalCouponFail.value.open();
    };

    const closeDialog = () => {
      issueExternalCouponFail.value.close();
    };

    const retry = () => {
      issueExternalCouponFail.value.close();
      props.retry();
    };

    return {
      props,
      issueExternalCouponFail,
      openDialog,
      closeDialog,
      retry,
    };
  },
};
</script>
  
  <style scoped lang="scss">
.text-center {
  text-align: center;
  font-size: 3vw;
}

.text-caution {
  text-align: center;
  margin-bottom: 1.5rem;
  font-weight: bold;
  font-size: 4vw !important;
}
</style>
  